var Commands = (function () {
    function Commands() {
    }
    Object.defineProperty(Commands, "SetTextToDataManagerCommand", {
        get: function () {
            return 'SET_TEXT_TO_DATAMANAGER_CONTROL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ChangeMenuCommand", {
        get: function () {
            return 'CHANGE_MENU';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ChangeMenuStateCommand", {
        get: function () {
            return 'CHANGE_MENU_STATE';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ChangeFocusControlCommand", {
        get: function () {
            return 'CHANGE_FOCUSED_CONTROL';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ChangeStatusCommand", {
        get: function () {
            return 'CHANGE_STATUS';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "CloseCommand", {
        get: function () {
            return 'CloseCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ClientCloseCommand", {
        get: function () {
            return 'ClientCloseCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "KeyPressCommand", {
        get: function () {
            return 'KeyPressCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "InputBoxActionCommand", {
        get: function () {
            return 'InputBoxActionCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalCommand", {
        get: function () {
            return 'ModalCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalCommandSessionExpired", {
        get: function () {
            return 'exp';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalCommandAlert", {
        get: function () {
            return 'alert';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalActionCommand", {
        get: function () {
            return 'ModalActionCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalActionButtonCommand", {
        get: function () {
            return 'ModalActionButtonCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "SendCommand", {
        get: function () {
            return 'SendCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "LoadingCommand", {
        get: function () {
            return 'LoadingCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "MessageBox", {
        get: function () {
            return 'msg';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "FileExplorerInput", {
        get: function () {
            return 'FILE_EXPLORER_WITH_INPUT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "FileExplorer", {
        get: function () {
            return 'FILE_EXPLORER';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "MsgBox", {
        get: function () {
            return 'MSGBOX';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "OpenView", {
        get: function () {
            return 'OpenView';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "CloseView", {
        get: function () {
            return 'CloseView';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "InputBox", {
        get: function () {
            return 'inputbox';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "PendingResponse", {
        get: function () {
            return 'PendingResponse';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "BringToFrontCommand", {
        get: function () {
            return 'BringToFrontCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "SessionExpiredCommand", {
        get: function () {
            return 'SessionExpiredCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "PrintActionCommand", {
        get: function () {
            return 'PrintActionCommand';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "RefreshApplicationMenu", {
        get: function () {
            return 'REFRESH_APPLICATION_MENU';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "QuitCurrentApplication", {
        get: function () {
            return 'QUIT_CURRENT_APPLICATION';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "PrintScreenCommand", {
        get: function () {
            return 'PRINT_SCREEN';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ContextMenuCommand", {
        get: function () {
            return 'CONTEXT_MENU';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "DisposeWindowCommand", {
        get: function () {
            return 'DISPOSE_WINDOW';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "CloseWindowByTimerCommand", {
        get: function () {
            return 'CLOSE_WINDOW_BY_TIMER';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "OpenExternalLinkCommand", {
        get: function () {
            return 'OPEN_EXTERNAL_LINK';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ServerVersionCommand", {
        get: function () {
            return 'SERVER_DCP_VERSION';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "DownloadFileCommand", {
        get: function () {
            return 'DOWNLOAD_FILE';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ArrangeWindowCommand", {
        get: function () {
            return 'ARRANGE_WINDOW';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "PopMenuCommand", {
        get: function () {
            return 'POP_MENU';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "GridPrintCommand", {
        get: function () {
            return 'GRID_PRINT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "StartEditCommand", {
        get: function () {
            return 'START_EDIT';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "StylesChangedCommand", {
        get: function () {
            return 'STYLES_CHANGED';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "UpdateRangesCommand", {
        get: function () {
            return 'UPDATE_RANGES';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ModalExecutionCommand", {
        get: function () {
            return 'MODAL_EXECUTION_COMMAND';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "ShowClientPrintersCommand", {
        get: function () {
            return 'SHOW_CLIENT_PRINTERS';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Commands, "PrintFileCommand", {
        get: function () {
            return 'PRINT_FILE';
        },
        enumerable: false,
        configurable: true
    });
    return Commands;
}());
export { Commands };
